import { INSURANCE_V3_ROUTES } from '@/views/insurance/config/insuranceV3Routes';

export default function isApplicantV3({ next, store, nextMiddleware }) {
  if (!store.GET_VALID('applicant')) {
    return next({
      name: INSURANCE_V3_ROUTES.applicant,
    });
  }

  return nextMiddleware();
}
